import * as moment from 'moment';

const numberNotNeedingPadding = 10;
const secondsInHour = 3600;
const secondsInMinute = 60;

const padZero = (num: number): string => {
   return num >= numberNotNeedingPadding ? `${num}` : `0${num}`;
};

const formatTime = (totalSeconds: number): string => {
   const negative = totalSeconds < 0 ? '-' : '';
   const roundedTotalSeconds = negative ? Math.round(totalSeconds * -1) : Math.round(totalSeconds);
   const hoursPlace = Math.floor(roundedTotalSeconds / secondsInHour);
   const secondsWithoutHours = roundedTotalSeconds % secondsInHour;
   const minutesPlace = Math.floor(secondsWithoutHours / secondsInMinute);
   const secondsPlace = secondsWithoutHours % secondsInMinute;

   if (hoursPlace > 0) {
      return `${negative}${hoursPlace}:${padZero(minutesPlace)}:${padZero(secondsPlace)}`;
   } else if (minutesPlace > 0) {
      return `${negative}${minutesPlace}:${padZero(secondsPlace)}`;
   }

   return `${negative}00:${padZero(secondsPlace)}`;
};

const formatTimeForSpeech = (totalSeconds: number): string => {
   const negative = totalSeconds < 0 ? '-' : '';
   const roundedTotalSeconds = negative ? Math.round(totalSeconds * -1) : Math.round(totalSeconds);
   return Math.floor(roundedTotalSeconds) === 0 ? '0 seconds' : new Date(roundedTotalSeconds * 1000).toISOString().substr(11, 8);
};

const formatDate = (uglyDate: string): string => {
   const date = moment.utc(uglyDate).local();
   const formatCode = date.isSame(new Date(), 'day') ? 'LT' : 'lll';
   return date.local().format(formatCode);
};

const getRoundedTime = (time: number): number => {
   return Math.floor(time * 1000) / 1000;
};

const formatDateWithNoLocalTimezoneAdjustment = (utcDateToFormat: Date) => {
   const dateWithTimezone = new Date(utcDateToFormat);
   // Add/subtract time to the date equal to the timezome adjustment for the users locale
   const dateAdjustedForTimezome = new Date(dateWithTimezone.getTime() + (dateWithTimezone.getTimezoneOffset() * secondsInMinute * 1000));
   // This will adjust the time back to the original, passed in time and return the date portion
   // formatted to the users locale
   return dateAdjustedForTimezome.toLocaleDateString();
};

const getReviewByDateAdjustedFromLocalTimezone = (date: Date) => {
   if (date) {
      return formatDateWithNoLocalTimezoneAdjustment(new Date(date));
   }

   return '';
};

export default {
   formatTime,
   formatTimeForSpeech,
   formatDate,
   getRoundedTime,
   formatDateWithNoLocalTimezoneAdjustment,
   getReviewByDateAdjustedFromLocalTimezone
};
